<template>
    <x-page title="Master Metric">
        <template #header-actions>
            <x-create-button url="/admin/metrics/create" 
                :disabled="isLoading"
                v-if="can('createMetrics')" />
        </template>

        <x-filter-box :onFilter="handleFilter"
            :onReset="resetFilter">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Nama">
                        <input class="form-control"
                            type="text"
                            v-model="filters.search"
                            @keyup.enter="() => handleFilter()"
                            placeholder="Masukkan nama" />
                    </x-form-group>
                </div>
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Kategori">
                        <x-input-metric-category class="form-control"
                            v-model="filters.category_id" />
                    </x-form-group>
                </div>
            </div>
        </x-filter-box>

        <x-table :headers="[
            '#',
            'Nama',
            'Kategori',
            '',
        ]" :is-loading="isLoading">
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link :to="`/admin/metrics/${resource.id}`" 
                        title="Klik untuk lihat detail">
                        {{ resource.name }}
                    </router-link>
                </td>
                <td>
                    {{ resource | get('category.name', '-') }}
                </td>
                <td>
                    <x-quick-edit-button :url="`/admin/metrics/${resource.id}/edit`"
                        :disabled="isLoading" v-if="can('updateMetrics')" />
                    <x-quick-delete-button @click="deleteResource(resource)"
                        :disabled="isLoading" v-if="can('deleteMetrics')" />
                </td>
            </tr>
        </x-table>

        <x-pagination v-if="shouldRenderPagination" :pagination="meta" />
    </x-page>
</template>

<script>
import XAjaxDropdown from '../../components/XAjaxDropdown.vue'
import XCreateButton from '../../components/XCreateButton.vue'
import XQuickDeleteButton from '../../components/XQuickDeleteButton.vue'
import XQuickEditButton from '../../components/XQuickEditButton.vue'
import XFilterBox from '../../components/XFilterBox.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import XPage from '../../components/XPage.vue'
import XTable from '../../components/XTable.vue'
import { deletePrompt, handleGeneralXhrError } from '../../helpers'
import FilterableMixin from '../../mixins/FilterableMixin'
import PaginationMixin from '../../mixins/PaginationMixin'
import PermissionMixin from '../../mixins/PermissionMixin'
import XInputMetricCategory from '../../components/XInputMetricCategory.vue'

const defaultFilters = {
    category_id: null,
    search: null,
}

export default {
    beforeRouteUpdate(to, from, next) {
		this.fetchResources(to)
		next()
	},
    components: {
        XCreateButton,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
        XFormGroup,
        XFilterBox,
        XAjaxDropdown,
        XInputMetricCategory,
    },
    created() {
        this.preselectFilters(defaultFilters)
        this.handleFilter().catch(() => {
            this.fetchResources()
        })
    },
    data() {
        return {
            filters: { ...defaultFilters },
            isLoading: false,
            resources: [],
        }
    },
    methods: {
        deleteResource(resource) {
            deletePrompt({
                name: resource.name,
                onConfirm: () => {
                    this.isLoading = true
                    const request = axios.delete(`/api/metrics/${resource.id}`)
                        .then(() => {
                            this.$notify({
                                type: 'success',
                                title: `Berhasil`,
                                text: `${resource.name} dihapus!`,
                            })
                            this.fetchResources()
                        })
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false
                    })
                },
            })
        },
        fetchResources(route = this.$route) {
            this.isLoading = true
            const request = axios.get('/api/metrics', {
                params: {
                    ...route.query,
                    with: 'category',
                    without_global_scopes: 1,
                }
            })
            .then(response => {
                this.resources = response.data.data
                this.setMeta(response)
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: 1,
                }),
            })
        },
        resetFilter() {
            this.filters = { ...defaultFilters }
            this.handleFilter()
        },
    },
    mixins: [
        FilterableMixin,
        PaginationMixin,
        PermissionMixin,
    ],
}
</script>